import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { visitaVirtualMapper } from '@/mappers';
import { loadAbort, buildStrapiUrl } from '@/utils';
import type { VisitaVirtualPageModel, StrapiSingleResponseModel } from '@/interfaces/model';
import type { DepartamentosPage, StrapiBaseRequest, VisitaVirtualPage } from '@/interfaces/strapi';

export const getVisitaVirtual = (params: StrapiBaseRequest): UseApiCall<VisitaVirtualPage> => {
	const controller = loadAbort();

	const { populate } = params ?? {};

	console.log('populate', populate);
	const url = buildStrapiUrl({
		base: '/visita-virtual',
		populate,
	});

	return {
		call: strapiInstance.get<VisitaVirtualPage>(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const parsed = JSON.parse(raw) as StrapiSingleResponseModel<VisitaVirtualPageModel>;
					return visitaVirtualMapper(parsed.data);
				},
			],
		}),
		controller,
	};
};
